import * as React from "react";

import { IndentSpacer } from "./TableUtils.styles";

export function renderChildrenWithIndent(children: React.ReactNode): React.ReactNode[] {
    const childrenWithIndent: React.ReactNode[] = [];
    React.Children.forEach(children ?? [], (child, index) => {
        if (index !== 0) {
            childrenWithIndent.push(<IndentSpacer key={`indent_${index}`} />);
        }
        if (React.isValidElement(child)) {
            childrenWithIndent.push(React.cloneElement(child, { key: index.toString() }));
        } else {
            childrenWithIndent.push(child);
        }
    });

    return childrenWithIndent;
}
